const KQUAKE_QC_URL = "https://quake.kigam.re.kr/api/qc/v1/";

export const getQc = async (starttime, endtime, streams) => {
  let endpoint = KQUAKE_QC_URL;

  const config = {};
  if (streams.length <= 100) {
    config.method = "GET";
    endpoint += `?start=${starttime}&end=${endtime}&stream=${streams.join()}`;
  } else {
    config.method = "POST";
    config.headers = { "Content-Type": "application/json" };
    config.body = JSON.stringify({
      start: starttime,
      end: endtime,
      streams,
    });
  }

  const response = await window.fetch(endpoint, config);
  if (response.status === 200) {
    return response.json();
  }
  throw new Error(response.statusText);
};
